import {
  ApolloClient,
  ApolloProvider as BaseApolloProvider,
  HttpLink,
  InMemoryCache,
} from '@apollo/client';
import { ReactNode, useCallback, useMemo } from 'react';
import { useTokenContext } from '../contexts/token/use_token_context';
import { setContext } from '@apollo/client/link/context';
import { getHeaders } from './apollo_register_header_provider';

interface ApolloProviderProps {
  children: ReactNode;
  apiEndpoint: string;
}

const ApolloCache = new InMemoryCache();

export const ApolloProvider = ({ children, apiEndpoint }: ApolloProviderProps) => {
  const { token } = useTokenContext();

  const getHttpLink = useCallback(() => new HttpLink({ uri: apiEndpoint }), [apiEndpoint]);

  const getAuthLink = useCallback(
    () =>
      setContext((_operations, { headers }) => {
        const newHeaders: Record<string, string> = {
          ...headers,
          ...getHeaders(),
          'Content-Type': 'application/json',
        };

        if (token) {
          newHeaders.authorization = `Bearer ${token}`;
        }

        return { headers: newHeaders };
      }),
    [token]
  );

  const apolloClient = useMemo(
    () =>
      new ApolloClient({
        link: getAuthLink().concat(getHttpLink()),
        cache: ApolloCache,
      }),
    [getAuthLink, getHttpLink]
  );

  return <BaseApolloProvider client={apolloClient}>{children}</BaseApolloProvider>;
};
